import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import styles from "./styles/style.module.scss";
import { useRouter } from "next/router";
import Image from "next/image";
import Link from "next/link";
import { FormattedMessage } from "react-intl";
import { buildWhatsAppUrl } from "../../../utils/whatsapp.mjs";

const RequirementsSection = ({ data, siteInfo }) => {
    const { locale } = useRouter();
    return (
        <section className={styles["requirements"]}>
            <Container className="d-flex flex-column align-items-center">
                <div className="header-container d-flex flex-column align-items-center justify-content-center mb-3">
                    {data?.heading && (
                        <h2 className="h2 fw-bold">
                            {data?.heading?.[locale]}
                        </h2>
                    )}
                    {data?.subHeading && <h2>{data?.subHeading?.[locale]}</h2>}
                </div>
                <Row className="gy-3">
                    <Col lg={6} md={12}>
                        <div className="items-container">
                            <div className="items-header">
                                {data?.papers?.title && (
                                    <h3 className="h4">
                                        {data?.papers?.title?.[locale]}
                                    </h3>
                                )}
                                {data?.papers?.description && (
                                    <p className="h5">
                                        {data?.papers?.description?.[locale]}
                                    </p>
                                )}
                            </div>
                            <div className="items">
                                {data?.papers?.items?.map((item, index) => (
                                    <div key={index} className="item">
                                        <div className="icon-container">
                                            <Image
                                                src={item?.icon}
                                                width={20}
                                                height={20}
                                                alt={item?.text}
                                                unoptimized
                                            />
                                        </div>
                                        <p>{item?.text?.[locale]}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </Col>
                    <Col lg={6} md={12}>
                        <div className="items-container">
                            <div className="items-header">
                                {data?.procedures?.title && (
                                    <h3 className="h4">
                                        {data?.procedures?.title?.[locale]}
                                    </h3>
                                )}
                                {data?.procedures?.description && (
                                    <p className="h5">
                                        {
                                            data?.procedures?.description?.[
                                                locale
                                            ]
                                        }
                                    </p>
                                )}
                            </div>
                            <div className="items">
                                {data?.procedures?.items?.map((item, index) => (
                                    <div key={index} className="item">
                                        <div className="icon-container">
                                            <Image
                                                src={item?.icon}
                                                width={20}
                                                height={20}
                                                alt={item?.text}
                                                unoptimized
                                            />
                                        </div>
                                        <p>{item?.text?.[locale]}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </Col>
                </Row>
                <div className="rounded-5 whatsapp">
                    <Link
                        href={buildWhatsAppUrl(siteInfo?.whatsup)}
                        aria-label="whatsapp"
                    >
                        <FormattedMessage id="send-whatsapp" />
                    </Link>
                </div>
            </Container>
        </section>
    );
};

export default RequirementsSection;
